import React from 'react';

import { SpeakerCard } from './SpeakerCard';

export const Conferencistas = ({ speakers = [] }) => {
  return (
    <div className="event-area section-padding bg-white">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="section-title-wrapper">
              <div className="section-title">
                <h3>CONFERENCISTAS</h3>
                <p></p>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {speakers.map((speaker) => (
            <SpeakerCard
              key={speaker.name}
              name={speaker.name}
              picture={speaker.picture}
              styleClass={speaker.styleClass}
              profile={speaker.profile}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
